import React from "react";
import {
	HubStatsLegendIcon,
	HubStatsLegendItem,
	HubStatsLegendPercents,
	HubStatsLegendTitle,
	HubStatsLegendWrapper
} from "apps/BWW_PLAY_HUB/components/HubStats/styles";
import { getByType, IRewardPoints } from "apps/BWW_PLAY_HUB/components/HubStats/utils";

interface IStatsLegend {
	items: Partial<IRewardPoints>[],
	show_value?: boolean;
	show_percent?: boolean;
	bordered?: boolean;
}

export const HubStatsLegend: React.FC<IStatsLegend> = ({
	items,
	show_value = true,
	show_percent = true,
	bordered = false,
}) => {
	return (
		<HubStatsLegendWrapper>
			{items.map((item, index) => {
				if ( !item.type ) {
					return null;
				}

				const dataByType = getByType(item.type);
				const custom_title = (item.title) ? item.title : dataByType.title;
				const custom_color = (item.color) ? item.color : dataByType.color;
				const title = ( show_value ) ? `${custom_title} - ${item.value || 0}` : custom_title;

				return (
					<HubStatsLegendItem key={index}>
						<HubStatsLegendIcon color={custom_color}
						                    bordered={bordered}/>
						<HubStatsLegendTitle>{title}</HubStatsLegendTitle>
						{show_percent &&
						<HubStatsLegendPercents>{item.percent}%</HubStatsLegendPercents>}
					</HubStatsLegendItem>
				)
			})}
		</HubStatsLegendWrapper>
	);
};
